<script lang="ts">
	//UI
	import { HubProfileBottomLineButton } from "@hitit/new_ui";
	import ProfileInputFrame from "./ProfileInputFrame.svelte";
	//Utils
	import { t, api } from "../../../stores";

	export let email = "";
	export let emailVerify = false;

	let sendLoading = false;

	async function sendVerifyEmail() {
		try {
			sendLoading = true;
			const r = await $api.requestVerificationEmail();
			console.log(r);
		} catch (e) {
		} finally {
			sendLoading = false;
		}
	}

</script>

<div class="container">
	<div class="frame">
		<ProfileInputFrame name={$t('hub.profile.email')}>
			<div class="email-box">
				<span class="value">{email}</span>
				<div class="email-verify-box" class:verify={emailVerify}>
					<span class:verify={emailVerify} class="emailVerify">
						{$t(emailVerify ? 'hub.profile.verified_email' : 'hub.profile.not_verified_email')}
					</span>
					{#if !emailVerify}
						<HubProfileBottomLineButton
							loading={sendLoading}
							on:click={sendVerifyEmail}
							let:hover={emailSendHover}>
							<span class="email-send" class:hover={emailSendHover}>
								{$t('hub.profile.resend_verify_email')}
							</span>
						</HubProfileBottomLineButton>
					{/if}
				</div>
			</div>
		</ProfileInputFrame>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	div {
		box-sizing: border-box;
	}

	.container {
		display: flex;
		flex-grow: 1;
		padding: 0 20px;
	}
	.frame {
		flex-grow: 1;
	}

	.email-box {
		display: flex;
		flex-direction: column;
		gap: 10px;
		flex-grow: 1;

		.value {
			font-weight: 500;
			color: #46474b;
		}

		.emailVerify {
			font-size: 0.85rem;
			color: #e54848;

			&.verify {
				color: #10c181;
			}
		}

		.email-verify-box {
			display: flex;
			justify-content: space-between;
			.email-send {
				@include appleAdjustTextForSize(14);
				color: #3c68d6;
				font-weight: 200;
				&.hover {
					color: var(--default-hover-btn-1);
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			padding: 0 40px;
		}
		.email-box {
			flex-direction: row;
			gap: 10px;
			flex-grow: 1;

			.value {
				font-size: 1.25rem;
			}

			.email-verify-box {
				display: flex;
				justify-content: space-between;
				flex-grow: 1;
				font-size: 1rem;

				.email-send {
					@include appleAdjustTextForSize(14, false);
				}

				&.verify {
					justify-content: flex-end;
				}

				.emailVerify {
					order: 1;
					font-size: 1rem;
				}
			}
		}
	}

</style>
